import FlexViewTwo from "../../components/FlexView/FlexViewTwo/FlexViewTwo"
import PrimaryCard from "../../components/cards/PrimaryCard"
import pagesNames from "../../constants/pages-names"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const ResourcesPageAr = () => {
  return (
    <main id="main" className="page">
      <div className="sticky-view">
        <div className="sticky-container">
          <MainHeader 
            title="محور الموارد في قضية الممارسات البيئية والاجتماعية والحوكمة المؤسسية"
            image={{
              src : require('../../assets/images/wallpaper/resource.jpg'),
              alt : "ESG Resource hub background"
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <div className="space-50"></div>
            <div className="space-50"></div>
            <p className="text-paragraph">تزامنًا مع تطور معايير إعداد التقارير واتساع رقعة تطبيقها على مستوى العالم، فقد كنا ولا نزال ملتزمين بتكييف نهجنا في التعامل مع الممارسات البيئية والاجتماعية والحوكمة المؤسسية وفق الإرشادات التوجيهية التنظيمية والأعراف المتبعة بالقطاعات التي نعمل بها.</p>
            <FlexViewTwo>
              <PrimaryCard
                title="التقارير"
                image={{
                  src : require(`../../assets/images/cards/resource-2.jpg`),
                  alt : "Resource card one"
                }}
                button={{
                  text : "أقرأ المزيد",
                  path : pagesNames.reports,
                }}
              /> 
              <PrimaryCard
                title="ملف الممارسات البيئية والاجتماعية والحوكمة المؤسسية"
                image={{
                  src : require(`../../assets/images/cards/resource-1.jpg`),
                  alt : "Resource card one"
                }}
                button={{
                  text : "أقرأ المزيد",
                  path : pagesNames.esgProfile,
                }}
              /> 
            </FlexViewTwo>

            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
          </div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  )
}

export default ResourcesPageAr